import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  dataMessage: null,
  error: false,
  success: false,
  isLoadingPushMessage: false,
  getMessageById: {
    success: null,
    error: null,
    isLoading: false,
  },
  putMessageById: {
    success: null,
    error: null,
    isLoading: false,
  },
};

const pushMessageSlice = createSlice({
  name: 'pushMessage',
  initialState,
  reducers: {
    GET_PUSH_MESSAGE: state => ({
      ...state,
      isLoadingPushMessage: true,
      success: false,
    }),
    SET_PUSH_MESSAGE: (state, { payload }) => ({
      ...state,
      isLoadingPushMessage: false,
      dataMessage: payload.message,
      success: true,
    }),
    ERROR_PUSH_MESSAGE: (state, { payload }) => ({
      ...state,
      isLoadingPushMessage: false,
      error: true,
    }),
    GET_MESSAGE_BY_ID: state => ({
      ...state,
      getMessageById: {
        success: null,
        error: null,
        isLoading: true,
      },
      putMessageById: initialState.putMessageById,
    }),
    GET_MESSAGE_BY_ID_SUCCESS: (state, { payload }) => ({
      ...state,
      getMessageById: {
        success: payload.message,
        error: null,
        isLoading: false,
      },
    }),
    GET_MESSAGE_BY_ID_FAIL: (state, { payload }) => ({
      ...state,
      getMessageById: {
        success: null,
        error: payload.error,
        isLoading: false,
      },
    }),
    PUT_MESSAGE_BY_ID: state => ({
      ...state,
      putMessageById: {
        success: null,
        error: null,
        isLoading: true,
      },
    }),
    PUT_MESSAGE_BY_ID_SUCCESS: (state, { payload }) => ({
      ...state,
      putMessageById: {
        success: payload.success,
        error: null,
        isLoading: false,
      },
    }),
    PUT_MESSAGE_BY_ID_FAIL: (state, { payload }) => ({
      ...state,
      putMessageById: {
        success: null,
        error: payload.error,
        isLoading: false,
      },
    }),
  },
});

export const {
  GET_PUSH_MESSAGE,
  SET_PUSH_MESSAGE,
  ERROR_PUSH_MESSAGE,
  GET_MESSAGE_BY_ID,
  GET_MESSAGE_BY_ID_SUCCESS,
  GET_MESSAGE_BY_ID_FAIL,
  PUT_MESSAGE_BY_ID,
  PUT_MESSAGE_BY_ID_SUCCESS,
  PUT_MESSAGE_BY_ID_FAIL,
} = pushMessageSlice.actions;

export const pushMessageSliceSelector = state => state.pushMessage;

export default pushMessageSlice.reducer;
